<template id="editable-column-dropdown">
  <div>
    <div v-if="isEditing
                  && (scope.row === editing.row)
                  && (scope.column.property === editing.column.property) ">
      <div class="col-md-12 col-sm-12">
        <select class="form-control"
                v-focus
                v-model="scope.row[property]"
                @blur="run"
                @keyup.enter="$emit('enter-input')">
          <option
            v-for="(value) in options"
            :value="value.id">
            {{value.name}}
          </option>
        </select>
      </div>
    </div>
    <!--<div v-else-if="isEditing
                  && (scope.row === editing.row)
                  && (scope.column.property === editing.column.property) ">
      <div class="col-md-12 col-sm-12">
        <select class="form-control"
                v-if="options && options.length > 0"
                v-focus
                v-model="scope.row[property]"
                @blur="run"
                @keyup.enter="$emit('enter-input')">
          <option
            v-for="(value) in options"
            :selected="value.name"
            :value="value">
            {{value.name}}
          </option>
        </select>
      </div>
    </div>
    <template v-else-if="returnObject && scope.row[property]">
      <span style="margin-left: 10px">{{ scope.row[property].name }}</span>
    </template>-->
    <template  v-else>
      <span style="margin-left: 10px">{{ scope.row[property] }}</span>
    </template>
  </div>
</template>

<script>
    export default {
        name: "EditableColumnTypeDropdown",
      props: ['is-editing', 'scope', 'editing', 'on-blur', 'on-enter', 'property','options'],
      methods:{
        run(){
          this.$emit('blur-input', {field: this.property, index: this.scope.$index, value: this.scope.row});
          // this.ociLog("run");
          // this.ociLog(this.scope.$index);
          // this.ociLog({field: this.property, index: this.scope.$index, value: this.scope.row[this.property]});
        }
      },
      mounted() {
          // this.ociLog(this.options);
        // this.ociLog("options============");
        // this.ociLog(this.options);
      },
      directives: {
        focus: {
          // directive definition
          inserted: function (el) {
            el.focus()
          }
        }
      }
    }
</script>

<style scoped>

</style>
